import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=346b3e5e&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=346b3e5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b3e5e",
  null
  
)

export default component.exports